import { useState } from 'react';
import {
  Box,
  Collapse,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useStyles } from './styles';
import useTexts from '../../hooks/useTexts';

const Footer = () => {
  const { classes } = useStyles();
  const texts = useTexts();
  const theme = useTheme();
  const [activeSection, setActiveSection] = useState<number | undefined>();
  const tablets = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Box className={classes.footer}>
        <Grid container className="container">
          <Grid item xs={12} lg={2}>
            <Typography
              variant="h5"
              color="textPrimary"
              mb={3}
              onClick={() =>
                setActiveSection(activeSection === 1 ? undefined : 1)
              }
            >
              {texts.FOOTER_NAME1}
              {tablets &&
                (activeSection === 1 ? <ExpandLess /> : <ExpandMore />)}
            </Typography>
            <Collapse in={!tablets || activeSection === 1} timeout="auto">
              <ul className={classes.columnList}>
                <li>
                  <a href="https://www.ppl.cz/o-nas">{texts.FOOTER_LINK11}</a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/mapa-vydejnich-mist">
                    {texts.FOOTER_LINK12}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/seznam-vydejnich-mist">
                    {texts.FOOTER_LINK13}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/prepravni-sit-ppl">
                    {texts.FOOTER_LINK14}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/aktualni-informace">
                    {texts.FOOTER_LINK15}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/kontakt-pro-media">
                    {texts.FOOTER_LINK16}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/osobni-udaje">
                    {texts.FOOTER_LINK17}
                  </a>
                </li>
                <li>
                  <a href="https://ppl.jobs.cz">{texts.FOOTER_LINK18}</a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/whistleblowing">
                    {texts.FOOTER_LINK19}
                  </a>
                </li>
              </ul>
            </Collapse>
          </Grid>
          <Grid item xs={12} lg={2}>
            <Typography
              variant="h5"
              color="textPrimary"
              mb={3}
              onClick={() =>
                setActiveSection(activeSection === 2 ? undefined : 2)
              }
            >
              {texts.FOOTER_NAME2}
              {tablets &&
                (activeSection === 2 ? <ExpandLess /> : <ExpandMore />)}
            </Typography>
            <Collapse in={!tablets || activeSection === 2} timeout="auto">
              <ul className={classes.columnList}>
                <li>
                  <a href="https://www.ppl.cz/vyhledat-zasilku">
                    {texts.FOOTER_LINK21}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/co-jsou-vydejni-mista">
                    {texts.FOOTER_LINK22}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/poslat-zasilku">
                    {texts.FOOTER_LINK23}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/vratit-zbozi">
                    {texts.FOOTER_LINK24}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/reklamace">
                    {texts.FOOTER_LINK25}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/zakaznicky-servis">
                    {texts.FOOTER_LINK26}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/mobilni-aplikace">
                    {texts.FOOTER_LINK27}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/ke-stazeni-osoby">
                    {texts.FOOTER_LINK28}
                  </a>
                </li>
              </ul>
            </Collapse>
          </Grid>
          <Grid item xs={12} lg={2}>
            <Typography
              variant="h5"
              color="textPrimary"
              mb={3}
              onClick={() =>
                setActiveSection(activeSection === 3 ? undefined : 3)
              }
            >
              {texts.FOOTER_NAME3}
              {tablets &&
                (activeSection === 3 ? <ExpandLess /> : <ExpandMore />)}
            </Typography>
            <Collapse in={!tablets || activeSection === 3} timeout="auto">
              <ul className={classes.columnList}>
                <li>
                  <a href="https://www.ppl.cz/stat-se-zakaznikem">
                    {texts.FOOTER_LINK31}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/poslat-zasilku">
                    {texts.FOOTER_LINK32}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/vnitrostatni-preprava">
                    {texts.FOOTER_LINK33}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/mezinarodni-preprava">
                    {texts.FOOTER_LINK34}
                  </a>
                </li>
                <li>
                  <a href="https://klient.ppl.cz/login.aspx?ReturnUrl=%2f">
                    {texts.FOOTER_LINK35}
                  </a>
                </li>
                <li>
                  <a href="https://www1.ppl.cz/main2.aspx?cls=loginZak">
                    {texts.FOOTER_LINK36}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/integratori">
                    {texts.FOOTER_LINK37}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/ke-stazeni-firmy">
                    {texts.FOOTER_LINK38}
                  </a>
                </li>
              </ul>
            </Collapse>
          </Grid>
          <Grid item xs={12} lg={2}>
            <Typography
              variant="h5"
              color="textPrimary"
              mb={3}
              onClick={() =>
                setActiveSection(activeSection === 4 ? undefined : 4)
              }
            >
              {texts.FOOTER_NAME4}
              {tablets &&
                (activeSection === 4 ? <ExpandLess /> : <ExpandMore />)}
            </Typography>
            <Collapse in={!tablets || activeSection === 4} timeout="auto">
              <ul className={classes.columnList}>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    id="ot-sdk-btn"
                    className="ot-sdk-show-settings"
                  >
                    {texts.FOOTER_LINK41}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/zakaznicky-servis">
                    {texts.FOOTER_LINK42}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/kontaktni-formular">
                    {texts.FOOTER_LINK43}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/reklamace">
                    {texts.FOOTER_LINK44}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/parcelshopy2">
                    {texts.FOOTER_LINK45}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/chci-provozovat-parcelbox">
                    {texts.FOOTER_LINK46}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/mam-zajem-provozovat-parcelshop">
                    {texts.FOOTER_LINK47}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/provozuji-parcelshop">
                    {texts.FOOTER_LINK48}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/reseni-sporu">
                    {texts.FOOTER_LINK49}
                  </a>
                </li>
                <li>
                  <a href="https://www.ppl.cz/dokumenty/obchodni-podminky">
                    {texts.FOOTER_LINK4X}
                  </a>
                </li>
              </ul>
            </Collapse>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Typography
              variant="h5"
              color="textPrimary"
              mb={3}
              onClick={() =>
                setActiveSection(activeSection === 5 ? undefined : 5)
              }
            >
              {texts.FOOTER_NAME5}
              {tablets &&
                (activeSection === 5 ? <ExpandLess /> : <ExpandMore />)}
            </Typography>
            <Collapse in={!tablets || activeSection === 5} timeout="auto">
              <Box mb={5} mt={2}>
                <Box mr={2} style={{ display: 'inline-block' }}>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/ppl-cz"
                    rel="noreferrer"
                  >
                    <img alt="Logo Linkedin" src="/img/linkedin.svg" />
                  </a>
                </Box>
                <Box mr={2} style={{ display: 'inline-block' }}>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/pplcz"
                    rel="noreferrer"
                  >
                    <img alt="Logo Facebook" src="/img/facebook.svg" />
                  </a>
                </Box>
                <Box mr={2} style={{ display: 'inline-block' }}>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/ppl.cz/"
                    rel="noreferrer"
                  >
                    <img alt="Logo Instagram" src="/img/instagram.svg" />
                  </a>
                </Box>
              </Box>

              <Typography variant="h5" mb={2} color="textPrimary">
                {texts.FOOTER_NAME6}
              </Typography>
              <ul className={classes.columnList}>
                <li>
                  <a
                    target="_blank"
                    href="https://apps.apple.com/cz/app/mojeppl/id6444147929"
                    rel="noreferrer"
                  >
                    <img alt="Logo AppStore" src="/img/app-store.svg" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=cz.ppl.mojeppl&pli=1"
                    rel="noreferrer"
                  >
                    <img alt="Logo GooglePlay" src="/img/google-play.svg" />
                  </a>
                </li>
              </ul>
            </Collapse>
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.moto}>
        <span>{texts.FOOTER_NAME7}</span>
      </Box>
    </>
  );
};

export default Footer;
